import { Typography } from '@mui/material';
import useCharLimiter from '../../../../hooks/UseCharLimiter';

interface LimiterInputProps {
  value: string;
  limit: number;
  placeholder: string;
  onChange: (value: string) => void;
  // Optional props =======
  label?: string;
  required?: boolean;
  textarea?: boolean;
}

export default function LimiterInput({
  value,
  limit,
  placeholder,
  onChange,
  label,
  // Optional props
  required = false,
  textarea = false,
}: LimiterInputProps) {
  const { hasExceeded, exceededChars } = useCharLimiter(value, limit);

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newDescription = e.target.value;
    onChange(newDescription);
  };

  return (
    <>
      {label && (
        <Typography variant="body2" className="text-bold mb-2">
          {label}

          {required && (
            <span
              style={{
                color: '#bb0000',
                fontSize: '80%',
                marginLeft: '4px',
                padding: '4px',
                borderRadius: '4px',
                backgroundColor: '#fff0f0',
              }}
            >
              必須
            </span>
          )}
        </Typography>
      )}

      {textarea ? (
        <textarea
          rows={5}
          value={value || ''}
          placeholder={placeholder}
          className="form-control mb-1"
          onChange={handleDescriptionChange}
          style={{
            borderColor: hasExceeded ? '#bb0000' : '#ced4da',
            backgroundColor: hasExceeded ? '#fff0f0' : '#ffffff',
          }}
        />
      ) : (
        <input
          type="text"
          value={value || ''}
          placeholder={placeholder}
          className="form-control mb-1"
          onChange={(e) => onChange(e.target.value)}
          style={{
            borderColor: hasExceeded ? '#bb0000' : '#ced4da',
            backgroundColor: hasExceeded ? '#fff0f0' : '#ffffff',
          }}
        />
      )}

      <Typography variant="caption">
        {`※${limit}文字以内で入力してください。`}

        {exceededChars > 0 && (
          <span>
            {' - '}
            <span
              style={{
                color: hasExceeded ? '#bb0000' : '#6c757d',
                fontSize: '0.75rem',
                marginTop: '4px',
              }}
            >
              {`${exceededChars}文字オーバーしています。`}
            </span>
          </span>
        )}
      </Typography>

      <br />
    </>
  );
}
